import { render } from "./GameStats.vue?vue&type=template&id=351b6a42&scoped=true"
import script from "./GameStats.vue?vue&type=script&lang=js"
export * from "./GameStats.vue?vue&type=script&lang=js"

import "./GameStats.vue?vue&type=style&index=0&id=351b6a42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351b6a42"]])

export default __exports__